
const Spinner = ()=> {
  return (
    <img width="100px" alt="spinner" height="100px" src="/assets/img/spinner.svg"></img>
  );
}

export default Spinner;
